import React from 'react';
import { NavLink } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import PropTypes from 'prop-types';
import './LsBreadcrumb.scss';

const LsBreadcrumb = ({ breadcrumbList }) => {
  return (
    <Breadcrumb listClassName="ls-breadcrumb mb-2">
      {breadcrumbList.map((item, i) => {
        return (
          <BreadcrumbItem
            key={item.name ? item.name : i}
            className="text-uppercase ls-breadcrumb-item"
          >
            <NavLink to={item.path} activeClassName="active">
              {item.name}
            </NavLink>
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};

LsBreadcrumb.propTypes = {
  breadcrumbList: PropTypes.array.isRequired,
};

export default React.memo(LsBreadcrumb);
